export const outputs = {
	outputs: {
		readMore: "続きを読む",
		externalNotice: "この記事は外部サイトで公開されています",
		readArticle: "記事を読む",
		backToOutputs: "アウトプット一覧に戻る",
	},

	talks: {
		viewTalk: "発表を見る",
	},
} as const;
